import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-point-of-contact',
  templateUrl: './point-of-contact.component.html',
  styleUrls: ['./point-of-contact.component.css'],
})
export class PointOfContactComponent implements OnInit {
  knowledgeForm: FormGroup;
  private saveApi = environment.url + 'preincubation/pointofcontact/save';
  private getApi = environment.url + 'preincubation/pointofcontact/get?userId=';
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    this.knowledgeForm = this.fb.group({
      id: [0],
      pocId: [0],
      applicationId: [0],
      hostinstheadname: ['', Validators.required],
      hostinstheaddesignation: ['', Validators.required],
      hostinstheadmobile: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      hostinstheademail: ['', [Validators.required, Validators.email]],

      picmanagername: [''],
      picmanagermobile: [
        '',
        [Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$')],
      ],
    });
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  get setting() {
    return this.knowledgeForm.controls;
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  roleName: any = '';
  /**
   * OnInit lifecycle hook
   * Initializes the component by fetching the point of contact data and setting the role name.
   */
  ngOnInit(): void {
    // Fetch the point of contact data
    this.getDataApi();

    // Set the role name
    this.roleName = sessionStorage.getItem('role');
  }
  getValue: any = {};
  showForm: boolean = true;
  /**
   * Fetches the point of contact data from the API and populates the form accordingly.
   * Also sets the 'showForm' flag to true or false based on the 'edit' value.
   */
  getDataApi() {
    this.getdata.amizhthLoader('show');
    // Fetch the point of contact data
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        // Set the 'showForm' flag based on the 'edit' value
        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        // Populate the form with the API response
        if (data.responseStatus != 'Failed') {
          this.knowledgeForm.patchValue(data);
          // Patch the form with the API response
          let getform = this.knowledgeForm.value;
          this.knowledgeForm.patchValue(getform);
        }
      });
  }
  userId = sessionStorage.getItem('userId');
  /**
   * Saves the knowledge form data to the API.
   * If the form is invalid, marks all fields as touched and shows an error notification.
   * If the form is valid, sends the form data to the API, shows a loading indicator,
   * and handles the API response by showing appropriate notifications and refetching data.
   */
  saveBtn() {
    // Retrieve form values
    let getform = this.knowledgeForm.value;

    // Check if the form is invalid
    if (this.knowledgeForm.invalid) {
      // Mark all fields as touched to show validation errors
      this.knowledgeForm.markAllAsTouched();
      // Show error notification
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Show loading indicator
      this.getdata.amizhthLoader('show');
      // Add user ID to form data
      getform.userid = this.userId;
      // Send form data to the API
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        // Hide loading indicator
        this.getdata.amizhthLoader('hide');
        // Check API response status
        if (data.responseStatus == 'Success') {
          // Show success notification
          this.notify.notifysuccess(data.responseMessage);
          // Refetch data from the API
          this.getDataApi();
        } else {
          // Show error notification
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
}
